import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

// import * as StoreState from 'x/modules/store/StoreState'
import { getSelectedStore } from 'x/redux/selectors'
import * as profileActions from 'x/modules/profile/ProfileState'

import ReportStockView from './ReportStockView'

export default connect(
  (state) => ({
    selectedStore: getSelectedStore(state),
    // myStores: getMyStores(state),
  }),
  (dispatch) => {
    return {
      searchMumber: bindActionCreators(profileActions.fetchProfileList, dispatch),
      // fetchInitializeData: bindActionCreators(StoreState.fetchInitializeData, dispatch),
      // fetchMyStore: bindActionCreators(StoreState.fetchMyStore, dispatch),
      dispatch,
    }
  }
)(ReportStockView)
